import { message } from "antd";
import { INSTALLATION_LIST_QUERY_KEY } from "hooks/queries/useInstallation";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "react-query";
import { AuthorizedService } from "shared/axios";

const END_POINT = "/installation";

export const usePublicAttachmentForCustomerStatus = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: { id: string; isForCustomer: boolean }) => {
      await new AuthorizedService().put(
        `${END_POINT}/public-attachment/${data.id}/status-customer`,
        data
      );
    },
    onSuccess: () => {
      message.success(t("status:changedSuccessfully"));
    },
    onError: () => {
      message.error(t("status:error"));
    },
    onSettled: () => {
      queryClient.invalidateQueries([INSTALLATION_LIST_QUERY_KEY]);
    },
  });
};
